/**
 * Vendor Application container
 */
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import vendorApplicationActions from './actions';
import { publicFilesUrlsSelector, vendorSelector } from './selectors';
import { currentUserSelector, loggedInSelector } from '../App/selectors';
import { userSelector } from '../User/selectors';
import InfluencerProfileV2 from '../../Components/InfluencerProfileV2/InfluencerProfile';
import ValidationAPI from '../../Lib/Api/validation';
import promisifyActions from '../../Lib/Utils/promisify-actions';

const {
  updateVendor,
  submitVendor,
  createVendorNetSuite,
  updateVendorNetSuite,
} = vendorApplicationActions;

function InfluencerProfileContainer(props) {
  return (
    <InfluencerProfileV2
      {...props}
      validateIBAN={ValidationAPI.validateIBAN}
      validateBIC={ValidationAPI.validateBIC}
      validateTIN={ValidationAPI.validateTIN}
    />
  );
}

/**
 * Properties to be provided to the Vendor Application component
 * @param {object} state global state
 */
const mapStateToProps = (state) => ({
  isLoggedIn: loggedInSelector(state),
  currentUser: currentUserSelector(state),
  vendor: vendorSelector(state),
  publicFilesUrls: publicFilesUrlsSelector(state),
  user: userSelector(state),
});

/**
 * Actions to be dispatched
 * @param {function} dispatch function to dispatch vendor application actions
 */
const mapDispatchToProps = (dispatch) => ({
  updateVendor: (userId, formData, fileUpload) =>
    dispatch(updateVendor(userId, formData, fileUpload)),
  createVendorNetSuite: (userId) => dispatch(createVendorNetSuite(userId)),
  submitVendor: (userId) => dispatch(submitVendor({ userId })),
  updateVendorNetSuite: (userId, vendor) =>
    dispatch(updateVendorNetSuite(userId, vendor)),
});

/**
 * Connects state to the Vendor Application component
 * @param {object} mapStateToProps data object to become props for the Vendor Application component
 * @param {object} mapDispatchToProps Vendor Application actions to be dispatched to reducer
 */
export default withRouter(
  connect(
    mapStateToProps,
    promisifyActions(mapDispatchToProps),
  )(InfluencerProfileContainer),
);
